import { Avatar as AvatarMat, SxProps } from '@mui/material';
import React, { useEffect, useState } from 'react';
import fallbackAvatar from '../assets/avatar.svg';

export interface AvatarProps {
  src?: string;
  sx?: SxProps;
}

const Avatar = ({ src = fallbackAvatar, sx }: AvatarProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    if (src) {
      setImgSrc(src);
    }
  }, [src]);

  return (
    <AvatarMat
      src={imgSrc}
      imgProps={{
        onError: () => {
          setImgSrc(fallbackAvatar);
        },
      }}
      sx={{ height: 32, width: 32, ...sx }}
    />
  );
};

export default Avatar;
